module.exports = __webpack_public_path__ + "img/提示燈泡.a08a7d3e.svg";